export default class IntroCtrl {
    constructor($scope, $state, IntroSteps) {
        this._scope = $scope;
        this._state = $state;
        this.introSteps = IntroSteps;
        this._scope.intro = introJs();
        this.introOptions = {
            steps: [],
            showStepNumbers: false,
            exitOnEsc: true,
            showBullets: false,
            scrollToElement: true,
            nextLabel: 'Next',
            prevLabel: 'Previous',
            skipLabel: 'End tour',
            doneLabel: 'Done'
        };

        this._scope.$watch(() => {
            return this._state.$current.name
        }, (newVal, oldVal) => {
            if (newVal != oldVal) {
                this.introSteps.getSteps(newVal).then((steps) => {
                    this.introOptions.steps = steps;
                });
            }
        });
        this._scope.$on('steps:loaded', (event, data) => {
            this.introSteps.getSteps(this._state.current.name).then((steps) => {
                this.introOptions.steps = steps;
            });
        });

        this._scope.$on('intro:language:selected', () => {
            this.introSteps.setSteps();
            this.introSteps.getSteps(this._state.current.name).then((steps) => {
                this.introOptions.steps = steps;
                this.startIntro();
            });
        });

        this._scope.intro.onchange((target) => {
            //step changed
        });

    }

    hasSelectedLanguage() {
        if (document.referrer) { // Hur göra med controllers scopade funktioner???
            var url = new URL(document.referrer);
            return url.pathname == '/signup/confirm' && ! this.hasShown;
        }

        return false;
    };

    startIntro() {
        this._scope.intro.setOptions(this.introOptions);
        this._scope.intro.start();
    };




};

// IntroCtrl.$inject = ['$scope', '$state', 'IntroSteps'];



/*angular.module('IntroApp').controller('IntroCtrl', function($scope, $state, IntroSteps) {
    $scope.intro = introJs();

    $scope.introOptions = {
        steps : [],
        showStepNumbers: false,
        exitOnEsc: true,
        showBullets: false,
        scrollToElement: true,
        nextLabel: 'Next',
        prevLabel: 'Previous',
        skipLabel: 'End tour',
        doneLabel: 'Done'
    };

    $scope.$watch(function() {
        return $state.$current.name
    }, function(newVal, oldVal) {
        if (newVal != oldVal) {
            IntroSteps.getSteps(newVal).then(function(steps) {
                $scope.introOptions.steps = steps;
            });
        }
    });
    
    $scope.hasSelectedLanguage = function () {
        if (document.referrer) {
            var url = new URL(document.referrer);
            return url.pathname == '/signup/confirm' && ! $scope.hasShown;
        }
        
        return false;
    };

    $scope.startIntro = function() {
        $scope.intro.setOptions($scope.introOptions);
        $scope.intro.start();
    };


    $scope.$on('steps:loaded', function (event, data) {
        IntroSteps.getSteps($state.current.name).then(function(steps) {
            $scope.introOptions.steps = steps;
        });
    });

    $scope.$on('intro:language:selected', function() {
        IntroSteps.setSteps();
        IntroSteps.getSteps($state.current.name).then(function(steps) {
            $scope.introOptions.steps = steps;
            $scope.startIntro();
        });
    });

    $scope.intro.onchange(function(target) {
        //step changed
    });

});*/
